const firebaseConfig = {
    apiKey: "AIzaSyD60tCXTljzhQ8IpMperA8vmGjF13G-sBw",
    authDomain: "health-care-73f51.firebaseapp.com",
    projectId: "health-care-73f51",
    storageBucket: "health-care-73f51.appspot.com",
    messagingSenderId: "685388806326",
    appId: "1:685388806326:web:33e835a231c40d1da90e17"
  };
  export default firebaseConfig;